import { render, staticRenderFns } from "./aiAdminChatSettings.vue?vue&type=template&id=06f6c08f&scoped=true"
import script from "./aiAdminChatSettings.vue?vue&type=script&lang=js"
export * from "./aiAdminChatSettings.vue?vue&type=script&lang=js"
import style0 from "./aiAdminChatSettings.vue?vue&type=style&index=0&id=06f6c08f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f6c08f",
  null
  
)

export default component.exports